export const CHANNELS = ["whatsapp", "email", "sms"];
export const OBJECTIVES = ["Marketing", "Promotional", "Transactional", "Announcement"];

export const CAMPAIGN_STATUS_COLOR = {
  Draft: "slate", "Pending Approval": "amber", Approved: "blue", Scheduled: "violet",
  Running: "teal", Completed: "green", Paused: "amber", Rejected: "red", Cancelled: "slate",
};
export const CHANNEL_COLOR = { whatsapp: "green", email: "blue", sms: "violet" };
export const RESPONSE_COLOR = {
  queued: "slate", sent: "blue", delivered: "teal", read: "green",
  replied: "green", failed: "red", opted_out: "amber",
};
